<div class="header" [ngClass]="{'notLogged': !logged}">
    <div class="busquedaContainer" *ngIf="logged" [ngClass]="{'active': busquedaActiva, 'resultadosActive': showResultados}">
        <div class="container position-relative">
            <div class="cajaBusqueda">
                <div class="regresarBoxHeader" (click)="toggleBusqueda('close')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18.004" height="31.519" viewBox="0 0 18.004 31.519"><path d="M5.154,16.411a2.253,2.253,0,0,0,0,3.185l13.5,13.5a2.252,2.252,0,0,0,3.185-3.185L9.928,18l11.9-11.911A2.254,2.254,0,0,0,18.647,2.9L5.147,16.4Z" transform="translate(-4.494 -2.241)" fill="#fff"/></svg> Cerrar
                </div>
                <div class="inputBox">
                    <input type="text"
                       #inputBusquedaHeader
                       (keydown.enter)="onEnterKey()"
                       (focus)="onInputFocus()"
                       (blur)="onInputBlur()"
                       placeholder="Buscar"
                       [(ngModel)]="busqueda">
                    <div class="clearBusqueda" *ngIf="busqueda.length > 0" (click)="clearBusqueda()"></div>
                </div>
                       
                <button [disabled]="busqueda == ''" class="btnBusqueda" (click)="buscar()"></button>
            </div>
        </div>
    </div>
    <div class="header-inner" [ngClass]="{'container': !logged}">
        <div class="d-flex d-lg-none align-items-center menuButton" *ngIf="logged">
            <div class="d-flex">
                <div class="pictoBox" (click)="toggleMenuMovil()">
                    <div *ngIf="!menuActive">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
                        </svg>
                    </div>
                    <div *ngIf="menuActive">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
                    </div>
                </div>
                <div class="notiBox d-flex align-items-center">
                    <div class="icon notificacion" [ngClass]="{'active': notificactioActive, 'on': notificactioOn}" (click)="abrirNotificacion()"></div>
                </div>
            </div>
        </div>

        <div class="uno" [ngStyle]="!logged ? {'padding-left' : 0} : {}">
            <a routerLink="/inicio" routerLinkActive="active" ariaCurrentWhenActive="page"><img src="../../../../assets/logoMedclass.png" class="logo"></a>
        
            <ul *ngIf="logged">
                <li><a routerLink="/inicio" routerLinkActive="active" ariaCurrentWhenActive="page">Inicio</a></li>
                <li><a routerLink="/masterclasses" routerLinkActive="active" ariaCurrentWhenActive="page">Masterclasses</a></li>
                <li><a routerLink="/sesiones" routerLinkActive="active" ariaCurrentWhenActive="page">Sesiones</a></li>
                <li *ngIf="shouldShowCapsulas()"><a routerLink="/capsulas" routerLinkActive="active" ariaCurrentWhenActive="page">Cápsulas</a></li>
                <li *ngIf="shouldShowCapsulas()"><a routerLink="/casos-clinicos" routerLinkActive="active" ariaCurrentWhenActive="page">Casos Clínicos</a></li>
                <li><a routerLink="/podcasts" routerLinkActive="active" ariaCurrentWhenActive="page">Podcasts</a></li>
                <li *ngIf="shortsEnabled && hasAvailableShorts"><a routerLink="/shorts" routerLinkActive="active" ariaCurrentWhenActive="page">Shorts</a></li>
                <li *ngIf="shouldShowPuntoCima()"><a [routerLink]="'/contenido/masterclass/' + contenidoEspecial" routerLinkActive="active" ariaCurrentWhenActive="page">Punto CIMA</a></li>
            </ul>
    
        </div>

        <div *ngIf="!logged" class="d-flex d-lg-none align-items-center dosMovil">
            <a href="https://silanespro.com.mx/login?webid=medclass&show=signup"><app-medclass-button type="red" label="Registrarse" size="s"></app-medclass-button></a>
            <a href="https://silanespro.com.mx/login?webid=medclass"><app-medclass-button type="white" label="Iniciar Sesión" size="s"></app-medclass-button></a>
        </div>
    
        <div class="dos" *ngIf="logged">
            <!-- <a routerLink="/alta-usuarios" routerLinkActive="active" ariaCurrentWhenActive="page" *ngIf="usuarioRepresentante">Registro de Usuarios</a> -->
            <!-- <a *ngIf="contenidoEspecial != ''" (click)="reloadRoute('/contenido/masterclass/' + contenidoEspecial)" routerLinkActive="active" ariaCurrentWhenActive="page"><mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="stars" class="me-2"></mat-icon> Carmen 3.0</a> -->
            <a routerLink="/mi-aprendizaje" routerLinkActive="active" ariaCurrentWhenActive="page">Mi Aprendizaje</a>
            <div class="iconBox" [ngClass]="{'active': notificactioActive}">
                <div class="icon search" (click)="toggleBusqueda()" [ngClass]="{'active': busquedaActiva}"></div>
                <div class="icon notifiacion ms-2" [ngClass]="{'active': notificactioActive, 'on': notificactioOn}" (click)="abrirNotificacion()"></div>
                <div class="notificationBox" [ngClass]="{'d-none': !notificactioActive}">
                    <a [href]="'contenido/' + notificacion.tipo +'/' + notificacion.id_contenido" *ngFor="let notificacion of notificacionesArr">
                        <div class="notificacion">
                            <div class="titNotificacion">{{notificacion.tipo == 'podcast'  ? 'Nuevo' : 'Nueva' }} {{notificacion.tipo}}</div>
                            <div class="tituloContenido">{{notificacion.titulo}}</div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="userWrapp">
                <div class="iconUser"></div>
                <div class="usuarioName">{{user.nombre}}</div>
                <div class="userDrop">
                    <a href="/usuario" class="userTab">
                        <div class="icon perfil"></div>
                        <div class="label">Perfil</div>
                    </a>
                    <a href="/mi-aprendizaje/favoritos" class="userTab">
                        <div class="icon favoritos"></div>
                        <div class="label">Favoritos</div>
                    </a>
                    <div class="userTab" (click)="cerrarSesion()">
                        <div class="icon cerrarSesion"></div>
                        <div class="label">Cerrar Sesión</div>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="dos" *ngIf="!logged" [ngStyle]="!logged ? {'padding-right' : 0} : {}">
            <a href="https://silanespro.com.mx/login?webid=medclass&show=signup"><app-medclass-button class="me-4" type="red" label="Registrarse" size="l"></app-medclass-button></a>
            <a href="https://silanespro.com.mx/login?webid=medclass"><app-medclass-button type="white" label="Iniciar Sesión" size="l"></app-medclass-button></a>
        </div>
    </div>
    <div class="notificationBoxMovil" [ngClass]="{'d-none': !notificactioActive}">
        <a [href]="'contenido/' + notificacion.tipo +'/' + notificacion.id_contenido" *ngFor="let notificacion of notificacionesArr">
            <div class="notificacion">
                <div class="titNotificacion">Nueva {{notificacion.tipo}}</div>
                <div class="tituloContenido">{{notificacion.titulo}}</div>
            </div>
        </a>
    </div>
    <a [href]="'webinar/'+webinarActivo._id" class="cintilloContainer" *ngIf="webinarActivo">
        <div class="nombreBox">
            <div class="nombreLabel">{{webinarActivo.texto}}</div>
        </div>
        <div class="enVivoBox">
            <img src="../../../../assets/live_icon.svg" alt="">
            <span>En vivo</span>
        </div>
    </a>
</div>
<div class="menuMobile" [ngClass]="{'active': menuActive}">
    <ul>
        <!-- <li *ngIf="contenidoEspecial != ''"><a [routerLink]="'/contenido/masterclass/' + contenidoEspecial" routerLinkActive="active" ariaCurrentWhenActive="page">Carmen 3.0 <mat-icon fontIcon="stars" class="ms-2"></mat-icon></a></li> -->
        <li><a routerLink="/inicio" routerLinkActive="active" ariaCurrentWhenActive="page">Inicio</a></li>
        <li><a routerLink="/masterclasses" routerLinkActive="active" ariaCurrentWhenActive="page">Masterclasses</a></li>
        <li *ngIf="shouldShowPuntoCima()"><a [routerLink]="'/contenido/masterclass/' + contenidoEspecial" routerLinkActive="active" ariaCurrentWhenActive="page">Punto CIMA</a></li>
        <li><a routerLink="/sesiones" routerLinkActive="active" ariaCurrentWhenActive="page">Sesiones</a></li>
        <li *ngIf="shouldShowCapsulas()"><a routerLink="/capsulas" routerLinkActive="active" ariaCurrentWhenActive="page">Cápsulas</a></li>
        <li *ngIf="shouldShowCapsulas()"><a routerLink="/casos-clinicos" routerLinkActive="active" ariaCurrentWhenActive="page">Casos Clínicos</a></li>
        <li><a routerLink="/podcasts" routerLinkActive="active" ariaCurrentWhenActive="page">Podcasts</a></li>
        <li *ngIf="shortsEnabled && hasAvailableShorts"><a routerLink="/shorts" routerLinkActive="active" ariaCurrentWhenActive="page">Shorts</a></li>
        <li><a routerLink="/mi-aprendizaje" routerLinkActive="active" ariaCurrentWhenActive="page">Mi Aprendizaje</a></li>
        <li *ngIf="usuarioRepresentante"><a routerLink="/alta-usuarios" routerLinkActive="active" ariaCurrentWhenActive="page">Registro de Usuarios</a></li>
        <li><a routerLink="/busqueda" routerLinkActive="active" ariaCurrentWhenActive="page">Búsqueda</a></li>
        <li><a routerLink="/usuario" routerLinkActive="active" ariaCurrentWhenActive="page">Mi Perfil</a></li>
        <li class="bottom" (click)="cerrarSesion()">Cerrar Sesión</li>
    </ul>
</div>
